import React from "react";
import { v4 } from "uuid";
import { FixedPointPicker } from "../Apps/maps/mapelements";
import StateLgaComponent from "../Apps/profile/StateLgaComponent";
import { VerificationDocument } from "../Apps/profile/VerificationDocument";
import { ImageUpload } from "./Forms";
import { FeatherIcon, getIcon } from "./Functions";

export const FormContent = (props) => {
	const { structure, updateProfile, PROFILE, readOnly, saveCategories } = props;
	const page = props?.page || 0;

	return (
		<>
			{structure.map((section, i) => {
				return (
					<div
						className={"form-fieldset pt-0 " + section.sectionClass}
						style={
							props?.formWizard
								? i === page
									? { display: "block" }
									: { display: "none" }
								: null
						}
					>
						<div className="fieldset-heading">
							<h4>{section.title}</h4>
							<p>{section.description}</p>
						</div>
						<div className="columns is-multiline">
							{section.fields.map((field) => {
								switch (field.type) {
									case "verification-documents":
										return <VerificationDocument userId={PROFILE.id} documents={PROFILE.documents} readOnly={readOnly} />
									case "location": 
										return <StateLgaComponent 
													{...field}
													readOnly={readOnly}
													address_lga={PROFILE.address_lga}
													address_state={PROFILE.address_state}
													setState={e => updateProfile({ address_state: e })}
													setLga={e => updateProfile({ address_lga: e })}
												/>
									case "photo":
										return (
											<div className="column is-12">
												<div className="field">
													<div className="user-image">
														<ImageUpload
															value={PROFILE.image}
															callback={(e) => updateProfile({ image: e })}
															readOnly={readOnly}
														/>
													</div>
												</div>
											</div>
										);
									case "location_from_map":
										return (
											<div className="column is-12">
												<div className="field">
													<FixedPointPicker
														{...props}
														addressLocation={
															PROFILE?.location_address_component
																? {
																		address: PROFILE?.location_address,
																		address_component: JSON.parse(
																			PROFILE?.location_address_component,
																		),
																		latLng: {
																			lat: PROFILE?.location_lat,
																			lng: PROFILE?.location_lng,
																		},
																  }
																: null
														}
														setLocationCallBack={(e) => {
															updateProfile(e);
														}}
													/>
												</div>
											</div>
										);
									case "background_image":
										return (
											<div className="column is-12">
												<div className="field">
													<label>{field.label}</label>
													<div className="background-profile-image">
														<ImageUpload
															value={PROFILE.background_image}
															callback={(e) =>
																updateProfile({ background_image: e })
															}
															readOnly={readOnly}
														/>
													</div>
												</div>
											</div>
										);

									case "categories_tags":
										return (
											<div className="column is-12">
												<div className="field">
													{/* <label>{field.label}</label> */}
													<div className="background-profile-image">
														{props?.categories?.map((field) => {
															const x = () => {
																let categories =
																	props?.selectedCategories || [];
																if (categories.includes(field.id))
																	categories.pop(field.id);
																else categories.push(field.id);
																return categories;
															};

															return (
																<button
																	onClick={(e) => {
																		updateProfile({ category: x() });
																		saveCategories(field.id);
																	}}
																	// key={field?.title}
																	{...(field?.title ? {key: field?.title} : {})}

																	className={`button h-button is-${
																		props?.selectedCategories?.includes(
																			field.id,
																		)
																			? "primary"
																			: "secondary"
																	} is-outlined mr-2 mb-2`}
																	style={{
																		borderWidth: 2,
																	}}
																>
																	{field?.title}
																</button>
															);
														})}
													</div>
												</div>
											</div>
										);

									case "select":
										return (
											<div className="column is-12">
												<div className="field">
													<label>
														{field.label}{" "}
														{field?.required ? (
															<span className="text-danger">*</span>
														) : null}
													</label>
													<div className="control">
														<div
															className="select"
															style={{ width: "100%" }}
															// key={`${PROFILE.id}.${
															// 	PROFILE[field.name] ?? null
															// }`}
															{...(PROFILE.id && PROFILE[field.name] ? { key: `${PROFILE.id}.${
																PROFILE[field.name] ?? null
															}` } : {})}
															
														>
															<select
																defaultValue={PROFILE[field.name] ?? null}
																readOnly={field?.readOnly || readOnly}
																onChange={(e) =>
																	updateProfile({
																		[field.name]: e.target.value,
																	})
																}
																className="input"
																style={{ width: "100%", height: 45 }}
															>
																{(field.options || []).map((item) => {
																	return (
																		<option value={item?.value || item}>
																			{item?.label || item}
																		</option>
																	);
																})}
															</select>
														</div>
													</div>
												</div>
											</div>
										);
									case "textarea":
										return (
											<div className="column is-12">
												<div
													className="field"

													// key={`${PROFILE.id}.${PROFILE[field.name] ?? null}`}
													{...(PROFILE.id && PROFILE[field.name] ? { key: `${PROFILE.id}.${
														PROFILE[field.name] ?? null
													}` } : {})}

												>
													<label>
														{field.label}{" "}
														{field?.required ? (
															<span className="text-danger">*</span>
														) : null}
													</label>
													<div className="control">
														<textarea
															onInput={(e) =>
																updateProfile({ [field.name]: e.target.value })
															}
															className="textarea input"
															rows="2"
															defaultValue={PROFILE[field.name] ?? null}
															readOnly={readOnly}
														></textarea>
													</div>
												</div>
											</div>
										);
									case "checkbox-list":
										return (
											<div className="filters-card">
												<div className="checkboxes-list">
													<div className="field">
														{(field.items || []).map((item, i) => {
															return (
																<div
																	className="control"

																	// key={`${PROFILE.id}.${
																	// 	PROFILE[field.name] ?? null
																	// }`}
																	{...(PROFILE.id && PROFILE[field.name] ? { key: `${PROFILE.id}.${
																		PROFILE[field.name] ?? null
																	}` } : {})}

																>
																	<label className="checkbox p-2">
																		<input
																			type="checkbox"
																			onChange={(e) =>
																				updateProfile({
																					[item.key]: e.target.checked,
																				})
																			}
																			name={item.key}
																			defaultChecked={
																				PROFILE[item.key] ?? false
																			}
																		/>
																		<span></span>
																		{item.name}
																	</label>
																</div>
															);
														})}
													</div>
												</div>
											</div>
										);
									case "checkbox-image":
										return (
											<div className="saas-billing-wrapper m-0 w-100">
												<div
													className="plans-wrapper mb-0 pb-2 w-100"
													style={{ border: "none" }}
												>
													<div className="left w-100" style={{ width: "100%" }}>
														<div className="inner-wrap w-100">
															<div className="plans w-100">
																{(field?.items || [])?.map((plan, i) => {
																	return (
																		<div
																			className="plan w-100"
																			data-logo-light="assets/img/illustrations/pricing/huro-starter.svg"
																			data-logo-dark="assets/img/illustrations/pricing/huro-starter-dark.svg"
																			style={{
																				pointerEvents: readOnly
																					? "none"
																					: "all",
																			}}

																			// key={`${PROFILE.id}.${
																			// 	PROFILE[field.name] ?? null
																			// }`}
																			{...(PROFILE.id && PROFILE[field.name] ? { key: `${PROFILE.id}.${
																				PROFILE[field.name] ?? null
																			}` } : {})}


																		>
																			<input
																				type="checkbox"
																				name="plan_selection_2"
																				onChange={(e) => {
																					if (field?.handleChange) {
																						field.handleChange({
																							[plan.key]: e.target.checked,
																						});
																					} else {
																						updateProfile({
																							[plan.key]: e.target.checked,
																						});
																					}
																				}}
																				defaultChecked={
																					PROFILE[plan.key] ||
																					plan?.value ||
																					false
																				}
																				readOnly={readOnly}
																			/>
																			<div className="plan-inner p-4xx">
																				<FeatherIcon icon={plan.icon} />
																				<div className="meta">
																					<span
																						dangerouslySetInnerHTML={{
																							__html: plan?.name,
																						}}
																					/>
																					<span
																						dangerouslySetInnerHTML={{
																							__html: plan?.description,
																						}}
																					/>
																				</div>
																				<div className="checkmark">
																					<svg
																						xmlns="http://www.w3.org/2000/svg"
																						width={24}
																						height={24}
																						viewBox="0 0 24 24"
																						fill="none"
																						stroke="currentColor"
																						strokeWidth={2}
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						className="feather feather-check"
																					>
																						<polyline points="20 6 9 17 4 12" />
																					</svg>
																				</div>
																			</div>
																		</div>
																	);
																})}
															</div>
														</div>
													</div>
												</div>
											</div>
										);
									default:
										return (
											<div className={`column is-${field.width || 12}`}>
												<div
													className="field"
													
													// key={`${PROFILE.id}.${PROFILE[field.name] ?? null}`}
													{...(PROFILE.id && PROFILE[field.name] ? { key: `${PROFILE.id}.${
														PROFILE[field.name] ?? null
													}` } : {})}

												>
													<label>
														{field.label}{" "}
														{field?.required ? (
															<span className="text-danger">*</span>
														) : null}
													</label>
													<div
														className={`control ${
															field.icon ? "has-icon" : ""
														}`}
													>
														<input
															defaultValue={PROFILE[field.name] ?? null}
															onInput={(e) =>
																updateProfile({ [field.name]: e.target.value })
															}
															type="text"
															className="input"
															placeholder
															readOnly={field?.readOnly || readOnly}
														/>
														{field.icon ? (
															<div
																className="form-icon"
																dangerouslySetInnerHTML={{
																	__html: getIcon(field.icon),
																}}
															/>
														) : null}
													</div>
												</div>
											</div>
										);
								}
							})}
						</div>
					</div>
				);
			})}
		</>
	);
};
